import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceShow16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.00011 4.96429C6.32353 4.96429 4.96439 6.32343 4.96439 8.00001C4.96439 9.67659 6.32353 11.0357 8.00011 11.0357C9.67669 11.0357 11.0358 9.67659 11.0358 8.00001C11.0358 6.32343 9.67669 4.96429 8.00011 4.96429ZM6.46439 8.00001C6.46439 7.15186 7.15196 6.46429 8.00011 6.46429C8.84826 6.46429 9.53582 7.15186 9.53582 8.00001C9.53582 8.84816 8.84826 9.53572 8.00011 9.53572C7.15196 9.53572 6.46439 8.84816 6.46439 8.00001Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.580909 7.3265C2.40887 5.13294 4.96797 2.75 7.99985 2.75C11.0317 2.75 13.5908 5.13294 15.4188 7.3265L15.4361 7.34651C15.7601 7.7219 15.7601 8.2781 15.4361 8.65349L15.4188 8.6735C13.5908 10.8671 11.0317 13.25 7.99985 13.25C4.96797 13.25 2.40887 10.8671 0.580909 8.6735C0.218352 8.23843 0.201116 7.78225 0.580909 7.3265ZM14.0207 8C12.5345 6.30885 10.3851 4.25 7.99985 4.25C5.61463 4.25 3.46515 6.30885 1.97898 8C3.46515 9.69115 5.61463 11.75 7.99985 11.75C10.3851 11.75 12.5345 9.69115 14.0207 8Z'
      fill='currentColor'
    />
  </Svg>
);

AppearanceShow16.displayName = 'AppearanceShow16';
export default AppearanceShow16;
